import { render } from "./PrerenderedMenu.vue?vue&type=template&id=660268ca"
import script from "./PrerenderedMenu.vue?vue&type=script&lang=js"
export * from "./PrerenderedMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__